import { apiServer } from "../config/config";
import { fetchWithToken } from "./fetchWithToken";
import type { AccessibilityLoadResponse } from "../types/accessibility";

/** A single tag inside a "matters to you" group. */
export interface MattersToYouOption {
  id: number;
  name: string;
  /** The filter-panel heading the tag applies under; absent = every heading. */
  heading_id?: number;
}

/**
 * One row of the onboarding "Tell us what matters to you" step. Selecting the
 * group means the user cares about all of its `children` tags.
 */
export interface MattersToYouGroup {
  group_name: string;
  /** Phosphor icon name in kebab-case, e.g. `speaker-simple-slash`. */
  icon: string;
  children: MattersToYouOption[];
}

export interface SubmitAccessibility {
  userId: number;
  ability: string;
  /** Comma-joined option ids — the legacy field; the phone app still sends it. */
  how_do_you_hear_about_us_ids: string;
  accessibility_need_selection: string;
  makeDisabilityVisibleValue: boolean;
  accessibilityFeatureRequestTagsValue: string;
  /** JSON `[{tag_id, heading_id}]` for the tags above that apply under one heading only. */
  accessibilityFeatureRequestPlacements?: string;
  /** Comma-joined `HearAboutUsGroup` ids. Takes over from the option ids above. */
  how_do_you_hear_about_us_group_ids?: string;
  /** Kept only for a group with `allows_other_text`. */
  how_do_you_hear_option_other_text?: string;
}

export async function fetchAccessibilities(): Promise<AccessibilityLoadResponse> {
  const response = await fetch(apiServer + "/accessibility/load");
  const data: AccessibilityLoadResponse = await response.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data;
}

export async function submitAccessibility(args: SubmitAccessibility) {
  console.log("submitAccessibility", args);
  const response = await fetch(apiServer + "/user/register-update", {
    method: "POST", // Specify the request method
    headers: {
      "Content-Type": "application/json", // Set the content type of the request
    },
    body: JSON.stringify(args), // Convert the JavaScript object to a JSON string
  });
  const data = await response.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data;
}

export async function postProfileUserAccessibility(
  abilities: string,
  need: string,
  accessToken: string
) {
  const formData = new FormData();
  formData.append("ability", abilities);
  formData.append("accessibility_need_selection", need);
  const response = await fetchWithToken(apiServer + "/user/profile-user-accessibility", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });
  const data = await response?.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data;
}
